import styled, { css } from 'styled-components';
import { size, spacing } from 'ui';

const getTypeColor = type => {
   switch (type) {
      case 'closed':
      case 'resolved':
         return 'rgba(0, 168, 156, 0.19)';
      case 'category':
         return '#fff';
      case 'emergency':
         return 'rgba(222, 37, 38, 0.19)';
      case 'acknowledged':
      case 'disfunction':
         return 'rgba(0, 157, 224, 0.19)';
      case 'opened':
      case 'open':
      default:
         return 'rgba(35, 120, 189, 0.19)';
   }
};

const getFontColor = type => {
   switch (type) {
      case 'closed':
      case 'resolved':
         return '#00A89C';
      case 'category':
         return '#fff';
      case 'emergency':
         return '#de2526';
      case 'acknowledged':
      case 'disfunction':
         return '#0062ab';
      case 'opened':
      case 'open':
      default:
         return '#2378bd';
   }
};

const ReportTagWrapper = styled.span`
   display: inline-block;
   color: ${({ kind }) => getFontColor(kind)};
   font-size: ${size(0)};
   padding: ${spacing(0.25)} ${spacing(0.75)};
   border-radius: 999px;
   background-color: ${({ kind }) => getTypeColor(kind)};
   margin-right: ${spacing(0.5)};

   ${props =>
      props.kind === 'category' &&
      css`
         color: rgba(0, 0, 0, 0.6);
         border: 1px solid rgba(0, 0, 0, 0.38);
      `};

   ${props =>
      props.marged &&
      css`
         margin-top: ${spacing()};
         margin-bottom: ${spacing(0.5)};
      `};

   ${props =>
      props.margedLeft &&
      css`
         margin-left: ${spacing(0.5)};
      `};

   ${props =>
      props.large &&
      css`
         font-size: ${size()};
      `};

   ${props =>
      props.flex &&
      css`
         display: flex;
         align-items: center;
      `};
`;

const ReportTag = ({ kind, marged, margedLeft, large, flex, displayName }) => (
   <ReportTagWrapper kind={kind} marged={marged} margedLeft={margedLeft} large={large} flex={flex}>
      {displayName}
   </ReportTagWrapper>
);

export default ReportTag;
